import { LogsService } from '@gtpl/shared-services/user-logs';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { ExpensesSubCategoryService } from '../expenses-sub-category/expenses-sub-category.service';
import { ExpensesCategoryAdapter } from './dto/expenses-category.adapter';
import { ExpensesCategoryController } from './expenses-category.controller';
import { ExpensesCategory } from './expenses-category.entity';
import { ExpensesCategoryService } from './expenses-category.service';

@Module({
  imports: [
    
    TypeOrmModule.forFeature([ExpensesCategory]),
    // forwardRef(() => ClusterModule),
  ],
  controllers: [ExpensesCategoryController],
  providers: [ExpensesCategoryService,ExpensesCategoryAdapter,ApplicationExceptionHandler,LogsService],
  exports: [ExpensesCategoryService]
})
export class ExpensesCategoryModule {}
